import { useEffect } from 'react'
import { useParams } from 'react-router'
import { useRecoilValue, useResetRecoilState, useSetRecoilState } from 'recoil'
import { AllCheckStatus, JoinTermsValue, RecoilStateList, uiTermsStyle } from 'src/recoil/common'
import {
  AllTermsContainer,
  CheckIcon,
  EachTermsContainer,
  EachTermsItems,
  TermsAgreeContents,
  TermsAgreeWrap,
} from 'src/styles/styledcomponent/views/RopForm/Terms'
import { monitoredOpen } from 'src/service/utils/sentry/navigation'
import { JoinTermsDetail } from 'src/types/type'

const Terms = (props: any): JSX.Element => {
  const params = useParams()
  const { TelType, AllTermsAgree, termsAgree, TermsData, isAgreeAllRequiredTerms } = useRecoilValue(RecoilStateList)
  const setAllTermsAgree = useSetRecoilState(AllCheckStatus)
  const setTermsAgree = useSetRecoilState(JoinTermsValue)
  const ResetJoinTerms = useResetRecoilState(JoinTermsValue)
  const {actColor, borderRadius} = useRecoilValue(uiTermsStyle)

  const termsOpen = (order: number): void => {
    // 약관 보기
    const width: number = 400
    const height: number = 600
    const url: string | undefined = params?.requestID
      ? `/terms/${params.requestID}/${TelType}/${TermsData.TermsIdx}/${order}`
      : undefined

    if (url) {
      monitoredOpen(url, 'termsOpen', '_blank', {
        windowFeatures: `width=${width}, height=${height}`,
      })
    }
  }

  const AllTerms = (): void => {
    // 전체동의
    const arrCopy = [...termsAgree]
    if (!AllTermsAgree) {
      TermsData?.Terms?.forEach((terms: JoinTermsDetail) => {
        if (terms.Order !== undefined && terms.Required === 1) {
          arrCopy[terms.Order - 1] = 1
        }
      })
    } else {
      arrCopy.fill(0)
    }
    setTermsAgree(arrCopy)
    setAllTermsAgree((AllTermsAgree) => !AllTermsAgree)
  }
  const EachTerms = (order: number): void => {
    // 개별동의
    const arrCopy = [...termsAgree]
    arrCopy[order - 1] = termsAgree[order - 1] === 1 ? 0 : 1
    setTermsAgree(arrCopy)
  }

  useEffect(() => {
    ResetJoinTerms()
    setAllTermsAgree(false)
  }, [ResetJoinTerms, TelType, TermsData, setAllTermsAgree])

  useEffect(() => {
    setAllTermsAgree(isAgreeAllRequiredTerms)
  }, [isAgreeAllRequiredTerms, setAllTermsAgree])

  return (
    <TermsAgreeWrap borderRadius={borderRadius}>
      <TermsAgreeContents>
        <AllTermsContainer checkColor={actColor} onClick={AllTerms} active={AllTermsAgree}>
          <span>
            <CheckIcon checkColor={actColor} primary />
          </span>
          <p>전체동의</p>
        </AllTermsContainer>
        <EachTermsContainer>
          {TermsData?.Terms?.map((terms: JoinTermsDetail, index: number) => (
            <EachTermsItems key={index} onClick={() => terms.Order !== undefined && EachTerms(terms.Order)}>
              <CheckIcon checkColor={actColor} active={terms.Order !== undefined && termsAgree[terms.Order - 1] === 1} />
              <p
                onClick={() => terms.Order !== undefined && termsOpen(terms.Order)}
              >
                {terms.Title}
                {terms.Required === 1 ? '' : '(선택)'}
              </p>
            </EachTermsItems>
          ))}
        </EachTermsContainer>
      </TermsAgreeContents>
    </TermsAgreeWrap>
  )
}
export default Terms
